// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/dist/cjs.js??ref--2-1!../node_modules/vue-loader/dist/stylePostLoader.js!../node_modules/postcss-loader/src/index.js??ref--2-2!../node_modules/sass-loader/dist/cjs.js!../node_modules/vue-loader/dist/index.js??ref--10-0!./tag-input.vue?vue&type=style&index=0&id=69648ea0&lang=css&scoped=true");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("2847aebd", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/dist/cjs.js??ref--2-1!../node_modules/vue-loader/dist/stylePostLoader.js!../node_modules/postcss-loader/src/index.js??ref--2-2!../node_modules/sass-loader/dist/cjs.js!../node_modules/vue-loader/dist/index.js??ref--10-0!./tag-input.vue?vue&type=style&index=0&id=69648ea0&lang=css&scoped=true", function() {
     var newContent = require("!!../node_modules/css-loader/dist/cjs.js??ref--2-1!../node_modules/vue-loader/dist/stylePostLoader.js!../node_modules/postcss-loader/src/index.js??ref--2-2!../node_modules/sass-loader/dist/cjs.js!../node_modules/vue-loader/dist/index.js??ref--10-0!./tag-input.vue?vue&type=style&index=0&id=69648ea0&lang=css&scoped=true");
     if(newContent.__esModule) newContent = newContent.default;
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}